import { computed } from "vue";
import { useAuthStore } from "~/stores/auth";
import { useVideoCallsStore } from "~/stores/videoCalls";
import { canStartVideoCall as canUserStartVideoCall } from "~/utils/videoCalls/policy";
import { isVideoCallRoutePath } from "~/utils/videoCalls/privacy";

export const useVideoCallLauncher = () => {
  const route = useRoute();
  const authStore = useAuthStore();
  const store = useVideoCallsStore();

  const canStartVideoCall = computed(
    () =>
      authStore.profileLoaded &&
      canUserStartVideoCall({
        isTeacher: authStore.user.permissions.isTeacher,
        featureEnabled: authStore.user.featureFlags?.video_calls === true,
      }),
  );

  // Only place the idle launcher here. Session initialization and restoration
  // stay in the global host so an ongoing call survives layout changes.
  const placement = computed<"sidebar" | "floating" | "hidden">(() => {
    if (
      !canStartVideoCall.value ||
      store.loading ||
      store.phase !== "idle" ||
      store.role === "guest" ||
      isVideoCallRoutePath(route.path) ||
      /^\/teaching-classes(?:\/|$)/.test(route.path)
    ) {
      return "hidden";
    }

    return ["teacher-dashboard", "school-teacher-dashboard"].includes(
      String(route.meta.layout),
    )
      ? "sidebar"
      : "floating";
  });

  return { canStartVideoCall, placement };
};
